import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={40} cy={40} r={40} fill="#000" fillOpacity={0.1} />
      <Circle cx={40} cy={40} r={32} fill="#000" fillOpacity={0.7} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.6 41.6c6.186 0 11.2-5.014 11.2-11.2 0-6.185-5.014-11.2-11.2-11.2-6.186 0-11.2 5.015-11.2 11.2 0 6.186 5.014 11.2 11.2 11.2zm-14.4 3.2a8 8 0 000 16h25.6a8 8 0 100-16H27.2z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 40c0 16.016-12.984 29-29 29S11 56.016 11 40s12.984-29 29-29a28.885 28.885 0 0118.74 6.867L18.171 58.433l3.395 3.394 40.566-40.566A28.885 28.885 0 0169 40zm3 0c0 17.673-14.327 32-32 32C22.327 72 8 57.673 8 40 8 22.327 22.327 8 40 8c17.673 0 32 14.327 32 32z"
        fill="#FF2E00"
      />
    </Svg>
  );
}

export default SvgComponent;
